import MainLayout from '../layouts/main';
import EduSubGroups from './edu-sub-groups';

function EduSubGroupsPage() {
  return (
    <MainLayout loginRequired={false} studentRequired={false} title={EDU_SUBGROUP_PAGE_TITLE}>
      <EduSubGroups />
    </MainLayout>
  );
}

export const EDU_SUBGROUP_PAGE_TITLE = 'توضیحات زیر‌گروه‌ها و ضرایب';

export default EduSubGroupsPage;
